import React, { FC } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { Header, Body, Typography } from "../styled";
import { format } from "date-fns";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";

const Attestation: FC = () => {
    return (
      <Box mt={1}>
        <Header>
            <Box display={'flex'}>
                <Typography mb={1} ml={10}>дата</Typography>
                <Typography mb={1} ml={40}>Специальность</Typography>
                <Typography mb={1} ml={42}>Категория</Typography>
            </Box>
            <Box display='flex'>
                <TextField
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "600px", mr: 1, mb: 1 }}
                />
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "600px", mr: 1, mb: 1 }}
                />
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "600px", mr: 1, mb: 1 }}
                />
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "600px", mr: 1, mb: 1 }}
                />
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "600px", mr: 1, mb: 1 }}
                />
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "600px", mr: 1, mb: 1 }}
                />
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "600px", mr: 1, mb: 2 }}
                />
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
            </Box>
        </Header>
        <Body>
            <Box display="flex" alignItems="center">
                <Typography mr={1} ml={1}>Вид аттестации</Typography>
                <TextField 
                    variant="outlined"
                    size="small"
                    sx={{ width: "120px", mb: 1, mr: 1, ml: 10}}
                />
                <TextField 
                    variant="outlined"
                    size="small"
                    sx={{ width: "472px", mb: 1 }}
                />
                <TextField
                    label="Дата аттестации"
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mb: 1, mr: 1, ml: 1}}
                />
            </Box>
            <Box display="flex" alignItems="center">
                <Typography mr={1} ml={1}>Специальность</Typography>
                <TextField 
                    variant="outlined"
                    size="small"
                    sx={{ width: "120px", mb: 1, mr: 1, ml: 10}}
                />
                <TextField 
                    variant="outlined"
                    size="small"
                    sx={{ width: "680px", mb: 1, mr: 1}}
                />
            </Box>
            <Box display="flex" alignItems="center">
                <Typography mr={15} ml={1}>Категория</Typography>
                <FormControlLabel
                    value="category"
                    control={<Radio />}
                    label="первая"
                />
                <FormControlLabel
                    value="category"
                    control={<Radio />}
                    label="вторая"
                />
                <FormControlLabel
                    value="category"
                    control={<Radio />}
                    label="высшая"
                />
            </Box>
            <Box display="flex" alignItems="center">
                <Typography mr={1} ml={1}>Результат</Typography>
                <TextField 
                    variant="outlined"
                    size="small"
                    sx={{ width: "120px", mb: 1, mr: 1, ml: 15.2}}
                />
                <TextField 
                    variant="outlined"
                    size="small"
                    sx={{ width: "680px", mb: 1, mr: 1}}
                />
            </Box>
            <Box display="flex" alignItems="center">
                <Typography mr={1} ml={1}>Номер документа</Typography>
                <TextField 
                    variant="outlined"
                    size="small"
                    sx={{ width: "120px", mb: 1, mr: 1, ml: 7.6}}
                />
                <TextField
                    label="Дата выдачи документа"
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mb: 1, mr: 1}}
                />
            </Box>
            <Box display="flex" alignItems="center">
                <Typography mr={1} ml={1}>Аттестация перенесена <br/> на дату</Typography>
                <TextField
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mb: 1, ml: 2.6, mr: 1}}
                />
                <TextField
                    label="Дата приказа"
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mb: 1, mr: 1}}
                />
                <TextField 
                    label="Номер приказа"
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mb: 1, mr: 1}}
                />
            </Box>
        </Body>
      </Box>
    );
  };

export default Attestation;

